import { API_TYPE } from "../../../utils/config";

export const EURAIL_STATION_LIST = API_TYPE("EURAIL_STATION_LIST");
export const EURAIL_STATION_TO_LIST = API_TYPE("EURAIL_STATION_TO_LIST");
export const EURAIL_TICKET_SEARCH = API_TYPE("EURAIL_TICKET_SEARCH");
export const GET_EURAIL_TICKET_LIST = API_TYPE("GET_EURAIL_TICKET_LIST");
export const GET_EURAIL_TICKET_HSID = API_TYPE("GET_EURAIL_TICKET_HSID");
export const EURAIL_TICKET_PRE_BOOK = API_TYPE("EURAIL_TICKET_PRE_BOOK");
export const EURAIL_TICKET_CHECKOUT = API_TYPE("EURAIL_TICKET_CHECKOUT");
export const EURAIL_CONFIG_KEY = API_TYPE("EURAIL_CONFIG_KEY");
export const GET_EURAIL_BOOKING_DETAILS = API_TYPE(
  "GET_EURAIL_BOOKING_DETAILS"
);
export const AGENT_GET_EURAIL_BOOKING_DETAILS = API_TYPE(
  "AGENT_GET_EURAIL_BOOKING_DETAILS"
);
export const EURAIL_SEGMENT_CHARGES = API_TYPE("EURAIL_SEGMENT_CHARGES");